<template>
    <div class="mobile-home">
        <div class="baomihua"></div>
        <div class="mobile-container">
            <div class="container-bg">
                <div class="bg-warp">
                    <div v-for="(item, index) in 11" :class="{o: index % 2 === 0}" :key="item"></div>
                </div>
            </div>
            <div class="mobile-content">
                <content1 />
                <content2 />
                <a id="bolwup"></a>
                <content3 />
                <a id="tokenomics"></a>
                <content4 />
                <a id="buy"></a>
                <content5 />
                <a id="roadmap"></a>
                <content6 />
            </div>
        </div>
    </div>
</template>

<script>
import content1 from "../../components/common/content1"
import content2 from "../../components/common/content2"
import content3 from "../../components/common/content3"
import content4 from "../../components/common/content4"
import content5 from "../../components/common/content5"
import content6 from "../../components/common/content6"
export default {
    name: 'PcHome',
    components: {
        content1,
        content2,
        content3,
        content4,
        content5,
        content6
    }
}
</script>

<style lang="less">
.mobile-home {
    width: 100%;
    padding-top: 4rem;
    .baomihua {
        width: 100%;
        height: 180px;
        background-image: url("../../assets/images/pc/header.png");
        background-position: center center;
        background-size: auto 150%;
    }
    .mobile-container {
        position: relative;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        min-height: 800px;
        top: -18px;
        padding-top: 48px;
        padding-bottom: 48px;
        .container-bg {
            position: absolute;
            width: 100%;
            height: calc(100% + 18px);
            top: 0;
            overflow: hidden;
            .bg-warp {
                width: 100%;
                height: 100%;
                display: flex;
                div {
                    flex: 1;
                    border-radius: 1024px 1024px 0 0;
                    background-color: #ffffff;
                    &.o {
                        background-color: #D0423F;
                    }
                }
            }
        }
        .mobile-content {
            position: relative;
            width: 100vw;
            overflow-x: hidden;
            padding-top: 6rem;
            margin-top: -6rem;
            .component-content1 {
                position: relative;
                width: 94%;
                background-color: #fff;
                margin: 0 auto;
                padding: 24px;
                border: solid 5px #000;
                border-radius: 24px;
                .title {
                    position: absolute;
                    width: 100vw;
                    top: 50%;
                    left: -24px;
                    display: flex;
                    justify-content: center;
                    margin-top: -12rem;
                    img {
                        width: 8rem;
                        height: 6.625rem;
                    }
                }
                .info {
                    /*text-align: justify;*/
                    font-size: 20px;
                }
                .button {
                    display: flex;
                    justify-content: center;
                    padding-top: 1rem;
                    button {
                        background-color: #FFD917;
                        padding: 0.3rem 1.2rem;
                        font-weight: bold;
                        border: solid 3px #000;
                        border-radius: 0.8rem;
                        font-family: Hamish;
                        font-size: 22px;
                    }
                }
            }
            .component-content2 {
                width: 94%;
                margin: 1.5rem auto;
                background: #ffffff;
                padding: 12px;
                border: solid 2px #DADADA;
                .content2-content {
                    border: solid 5px #000;
                    padding: 1rem;
                    position: relative;
                    .img1 {
                        position: absolute;
                        right: -3rem;
                        top: -1rem;
                        img {
                            width: 4rem;
                        }
                    }
                    .img2 {
                        position: absolute;
                        left: -310px;
                        top: 320px;
                        display: none;
                        img {
                            width: 80px;
                        }
                    }
                    .title {
                        font-size: 20px;
                    }
                    .price {
                        font-size: 28px;
                        font-weight: bold;
                        font-family: Hamish;
                        padding: 4px 0;
                    }
                    .form {
                        border: solid #000;
                        border-width: 16px 0 15px 0;
                        .item {
                            border-bottom: solid 2px #000;
                            display: flex;
                            justify-content: space-between;
                            padding: 16px 0 6px 0;
                            label {
                                font-size: 20px;
                            }
                            .value {
                                font-family: Hamish;
                                font-size: 22px;
                            }
                        }
                    }
                    .button {
                        display: flex;
                        justify-content: center;
                        padding-top: 1.2rem;
                        button {
                            background: #000;
                            padding: 0.3rem 1rem;
                            border-radius: 5px;
                            color: #fff;
                            font-size: 22px;
                            a {
                                color: #fff;
                            }
                        }
                    }
                }
            }
            .component-content3 {
                width: 94%;
                margin: 5rem auto 0 auto;
                position: relative;
                background: #fff;
                min-height: 200px;
                padding: 2.4rem 1.2rem 2.4rem 1.2rem;
                border: solid 5px #000;
                border-radius: 24px;
                position: relative;
                .img1 {
                    position: absolute;
                    right: -190px;
                    top: 60px;
                    display: none;
                    img {
                        width: 120px;
                    }
                }
                .img2 {
                    position: absolute;
                    right: 0rem;
                    top: 20rem;
                    img {
                        width: 4rem;
                    }
                }
                .img3 {
                    position: absolute;
                    right: 180px;
                    bottom: -60px;
                    display: none;
                    img {
                        width: 80px;
                    }
                }
                .img4 {
                    position: absolute;
                    left: -220px;
                    bottom: -10px;
                    display: none;
                    img {
                        width: 90px;
                    }
                }
                .icon {
                    position: absolute;
                    top: 0;
                    left: -15px;

                    .img-1 {
                        position: relative;
                        z-index: 0;

                        img {
                            width: 4rem;
                        }
                    }
                    .img-2 {
                        position: absolute;
                        z-index: 1;
                        top: -4.6rem;
                        left: 1.5rem;
                        img {
                            width: 16rem;
                        }
                    }
                }
                .content {
                    font-size: 20px;
                    /*text-align: justify;*/
                }
                .button {
                    display: flex;
                    justify-content: center;
                    padding-top: 1.4rem;
                    button {
                        background-color: #FFD917;
                        padding: 0.3rem 1rem;
                        font-weight: bold;
                        border: solid 3px #000;
                        border-radius: 11px;
                        font-family: Hamish;
                        font-size: 22px;
                    }
                }
            }
            .component-content4 {
                width: 94%;
                margin: 8rem auto 0 auto;
                position: relative;
                background: #fff;
                min-height: 200px;
                padding: 2rem 1.8rem 2rem 1.8rem;
                border: solid 5px #000;
                border-radius: 24px;
                .img1 {
                    position: absolute;
                    left: -320px;
                    top: 1000px;
                    display: none;
                    img {
                        width: 100px;
                    }
                }
                .img2 {
                    position: absolute;
                    left: -200px;
                    top: 1100px;
                    display: none;
                    img {
                        width: 80px;
                    }
                }
                .img3 {
                    position: absolute;
                    right: -190px;
                    top: 1300px;
                    display: none;
                    img {
                        width: 110px;
                    }
                }
                .img4 {
                    position: absolute;
                    left: -1rem;
                    bottom: -1rem;
                    img {
                        width: 4rem;
                    }
                }
                .img5 {
                    position: absolute;
                    left: -294px;
                    bottom: -194px;
                    display: none;
                    img {
                        width: 110px;
                    }
                }
                .icon {
                    position: absolute;
                    top: -5rem;
                    left: 4.6rem;

                    .img-1 {
                        position: relative;
                        z-index: 0;
                        img {
                            width: 8rem;
                        }
                    }
                    .img-2 {
                        position: absolute;
                        z-index: 1;
                        top: -3rem;
                        left: -5.6rem;
                        img {
                            width: 9rem;
                        }
                    }
                    .img-3 {
                        position: absolute;
                        z-index: 1;
                        top: 0rem;
                        left: 6rem;
                        img {
                            width: 11rem;
                        }
                    }
                }
                .content {
                    font-size: 20px;
                    /*text-align: justify;*/
                    padding: 1.5rem 0 0 1.2rem;
                    position: relative;
                    h2 {
                        color: #D0423F;
                        font-size: 22px;
                        margin-bottom: 24px;
                    }
                    .icon {
                        position: absolute;
                        top: 12rem;
                        left: -4rem;
                        img {
                            width: 6rem;
                        }
                    }
                }
                .address {
                    width: calc(100% + 3.6rem);
                    margin-left: -1.8rem;
                    padding: 1.2rem 0.5rem;
                    background-color: rgba(0, 0, 0, 0.05);
                    position: relative;
                    h2 {
                        color: #D0423F;
                        font-size: 20px;
                        margin-bottom: 24px;
                        text-align: center;
                        padding-right: 5rem;
                    }
                    .number {
                        position: relative;
                        border: solid 3px #000;
                        font-size: 14px;
                        background-color: #FFD917;
                        padding: 12px 0;
                        border-radius: 11px;
                        text-align: center;
                        z-index: 1;
                    }
                    .img {
                        position: absolute;
                        right: 0;
                        top: 8px;
                        z-index: 0;
                        img {
                            width: 8rem;
                        }
                    }
                    .bottom {
                        height: 26px;
                        display: flex;
                        justify-content: space-between;
                        span {
                            width: 12px;
                            background-color: #000;
                            border-radius: 0 0 3px 3px;
                            &:first-of-type {
                                margin-left: 6rem;
                            }
                            &:last-of-type {
                                margin-right: 6rem;
                            }
                        }
                    }
                }
                .button {
                    display: flex;
                    justify-content: center;
                    padding-top: 24px;
                    button {
                        background-color: #FFD917;
                        padding: 6px 24px;
                        font-weight: bold;
                        border: solid 3px #000;
                        border-radius: 11px;
                        font-family: Hamish;
                        font-size: 18px;
                    }
                }
            }
            .component-content5 {
                width: 94%;
                margin: 6rem auto 0 auto;
                position: relative;
                background: #fff;
                min-height: 200px;
                padding: 3rem 1rem 2rem 1rem;
                border: solid 5px #000;
                border-radius: 24px;
                .img1 {
                    position: absolute;
                    right: -190px;
                    top: 200px;
                    display: none;
                    img {
                        width: 8rem;
                    }
                }
                .img2 {
                    position: absolute;
                    right: -290px;
                    top: 240px;
                    display: none;
                    img {
                        width: 70px;
                    }
                }
                .img3 {
                    position: absolute;
                    right: -240px;
                    top: 580px;
                    display: none;
                    img {
                        width: 100px;
                    }
                }
                .img4 {
                    position: absolute;
                    left: -240px;
                    bottom: 120px;
                    display: none;
                    img {
                        width: 100px;
                    }
                }
                .img5 {
                    position: absolute;
                    left: -2rem;
                    bottom: 0rem;
                    img {
                        width: 5rem;
                    }
                }
                .img6 {
                    position: absolute;
                    right: 3rem;
                    bottom: -1rem;
                    img {
                        width: 4rem;
                    }
                }
                .icon {
                    position: absolute;
                    top: -3rem;
                    left: 11rem;

                    .img-1 {
                        position: relative;
                        z-index: 0;

                        img {
                            width: 6rem;
                        }
                    }
                    .img-2 {
                        position: absolute;
                        z-index: 1;
                        top: -4rem;
                        left: -8.5rem;
                        img {
                            width: 11rem;
                        }
                    }
                }
                .content {
                    font-size: 20px;
                    /*text-align: justify;*/
                }
                .button {
                    display: flex;
                    justify-content: center;
                    padding-top: 1rem;
                    padding-bottom: 24px;
                    button {
                        background-color: #FFD917;
                        padding: 0.3rem 1rem;
                        font-weight: bold;
                        border: solid 3px #000;
                        border-radius: 11px;
                        font-size: 22px;
                    }
                }
                .tabs {
                    border: solid 5px #000;
                    border-radius: 9px;
                    margin-top: 2rem;
                    .tab {
                        display: flex;
                        justify-content: center;
                        padding-top: 16px;
                        position: relative;
                        span {
                            flex: 1;
                            text-align: center;
                            font-size: 20px;
                            position: relative;
                            z-index: 5;
                            cursor: pointer;
                        }
                        div {
                            width: 25%;
                            position: absolute;
                            background-color: #D0423F;
                            height: 0.8rem;
                            border-radius: 0.4rem;
                            padding: 0 0.2rem;
                            top: 2rem;
                            left: 0;
                            z-index: 1;
                            transition: transform 0.5s;
                            transform: translateX(0);
                            &.active0 {
                                transform: translateX(0);
                            }
                            &.active1 {
                                transform: translateX(100%);
                            }
                            &.active2 {
                                transform: translateX(200%);
                            }
                            &.active3 {
                                transform: translateX(300%);
                            }
                        }
                    }
                    .tab-content {
                        width: 100%;
                        overflow: hidden;
                        .step-list {
                            width: 400%;
                            display: flex;
                            min-height: 100px;
                            transition: transform 0.5s;
                            &.active0 {
                                transform: translateX(0);
                            }
                            &.active1 {
                                transform: translateX(-25%);
                            }
                            &.active2 {
                                transform: translateX(-50%);
                            }
                            &.active3 {
                                transform: translateX(-75%);
                            }
                            .info {
                                flex: 1;
                                padding: 1.2rem 1rem;
                                font-size: 20px;
                                /*text-align: justify;*/
                                h2 {
                                    text-align: center;
                                    color: #D0423F;
                                    border: solid 3px #D0423F;
                                    padding: 0.3rem 0;
                                    border-radius: 9px;
                                    font-size: 20px;
                                    width: 90%;
                                    margin: 0 auto 1.5rem auto;
                                }
                                a {
                                    color: #3550D7;
                                }
                                label {
                                    color: #4F4F4F;
                                }
                                .tables {
                                    width: 100%;
                                    display: flex;
                                    background-color: rgba(0, 0, 0, 0.05);
                                    div {
                                        flex: 1;
                                        word-break: break-all;
                                        font-size: 20px;
                                        line-height: 22px;
                                        padding-right: 12px;
                                    }
                                    button {
                                        width: 4rem;
                                        background-color: #FFD917;
                                        border: solid 3px #000;
                                        border-radius: 9px;
                                        font-size: 20px;
                                        line-height: 22px;
                                        height: 3rem;
                                        overflow: hidden;
                                        padding-bottom: 8px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .component-content6 {
                width: 94%;
                margin: 4rem auto 0 auto;
                position: relative;
                background: #fff;
                min-height: 200px;
                padding: 0.5rem;
                border: solid 4px #000;
                .img1 {
                    position: absolute;
                    top: 486px;
                    right: 68px;
                    display: none;
                    img {
                        width: 80px;
                    }
                }
                .icon {
                    position: absolute;
                    top: 1rem;
                    left: 0.2rem;

                    .img-1 {
                        position: relative;
                        z-index: 0;

                        img {
                            width: 6rem;
                        }
                    }
                    .img-2 {
                        position: absolute;
                        z-index: 1;
                        top: -3.4rem;
                        left: 3.2rem;
                        img {
                            width: 13rem;
                        }
                    }
                }
                .content {
                    font-size: 20px;
                    /*text-align: justify;*/
                    border: solid 4px #000;
                    .title {
                        background-color: #D0423F;
                        margin: 1.2rem 0;
                        padding: 1.2rem 1rem 1.2rem 7rem;
                        color: #fff;
                        font-size: 20px;
                    }
                    .line {
                        padding-top: 8px;
                        .checkbox {
                            width: 2rem;
                            height: 2rem;
                            border: solid 5px #000;
                            background-color: #fff;
                            position: relative;
                            img {
                                width: 2.4rem;
                                position: absolute;
                                left: -0.2rem;
                                top: -0.4rem;
                            }
                        }
                    }
                    .info {
                        padding: 0 0;
                        position: relative;
                        .time-line {
                            position: absolute;
                            width: 8px;
                            background-color: #000;
                            height: 100%;
                            top: 15px;
                            left: 7.7rem;
                            z-index: 0;
                        }
                        .item {
                            display: flex;
                            padding-bottom: 36px;
                            position: relative;
                            z-index: 1;
                            .date {
                                width: 7rem;
                                text-align: right;
                                padding-right: 0.4rem;
                                font-size: 20px;
                                letter-spacing: -0.1rem;
                            }
                            .line {
                                width: 3.2rem;
                            }
                            .text {
                                flex: 1;
                                text-align: left;
                                font-size: 18px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
